import React from "react";
import { usePanelTheme } from "../context/themeContext";

export default function UILabel({ children, className = "" }) {
  const { theme } = usePanelTheme();

  return (
    <label
      className={`mb-2 block text-sm font-semibold ${
        theme === "dark" ? "text-slate-300" : "text-slate-700"
      } ${className}`}
    >
      {children}
    </label>
  );
}